import React, { useState } from "react";

const RefreshDistMonthWiseSales = () => {
  const [result, setResult] = useState(0);
  const [message, setMessage] = useState("");

  const start = () => {
    fetch(`${process.env.REACT_APP_URL}/api/month-wise-sales`, {
      method: "POST",
      headers: { "Content-Type": "application/json" }
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Internal Server Error");
        }
        return res.json();
      })
      .then((data) => {
        setResult(data.result);
        setMessage(data.message);
      })
      .catch(() => {
        setResult(0);
        setMessage("Internal Server Error");
      });
  };

  return (
    <div style={{ padding: "20px" }}>
      <table
        align="center"
        width="50%"
        border="1"
        cellPadding="10"
        style={{ borderCollapse: "collapse" }}
      >
        <tbody>
          <tr className="tableheader">
            <td colSpan="2" align="center">
              <b>Refresh Month Wise Sales Records</b>
            </td>
          </tr>

          {result !== 1 ? (
            <tr>
              <td align="center">Month Wise Sales</td>
              <td align="center">
                <input
                  type="button"
                  className="button button2"
                  value="Refresh Data"
                  onClick={start}
                />
              </td>
            </tr>
          ) : (
            <tr>
              <td
                colSpan="2"
                align="center"
                style={{
                  borderLeft: "none",
                  borderRight: "none",
                  fontWeight: "bold"
                }}
              >
                Month Wise Sales
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {result === 1 && message && (
        <>
          <br />
          <div
            align="center"
            style={{
              color: "brown",
              marginTop: "30px", 
              textDecoration: "underline",
              fontWeight: "bold",
              fontSize: "18px"
            }}
          >
            {message}
          </div>
        </>
      )}

      {result === 0 && message && (
        <>
          <br />
          <div
            align="center"
            style={{
              color: "red",
              fontWeight: "bold",
              fontSize: "16px"
            }}
          >
            {message}
          </div>
        </>
      )}
    </div>
  );
};

export default RefreshDistMonthWiseSales;
